import { useEffect, useState } from "react";
import { api } from "../api";

const platformIcon = { shopee: "🛍️", lazada: "🔵", tiktok: "🎵" };
const platformLabel = { shopee: "Shopee", lazada: "Lazada", tiktok: "TikTok Shop" };

export default function StoreSelectModal({ onClose, onPick }) {
  const [stores, setStores] = useState([]);
  const [platform, setPlatform] = useState("shopee");
  const [country, setCountry] = useState("MY");

  useEffect(() => {
    api.get("/stores").then((r) => setStores(r.data)).catch(() => setStores([]));
  }, []);

  const filtered = stores.filter((s) => s.platform === platform && s.country === country);

  return (
    <div className="store-screen" data-testid="store-select-modal" onClick={(e) => e.target.className === "store-screen" && onClose()}>
      <div className="store-modal">
        <div className="store-modal-header">
          <div>
            <div className="store-modal-title">Select Store</div>
            <div className="store-modal-sub">Choose platform and country, then authenticate into store</div>
          </div>
          <div className="modal-close" onClick={onClose} data-testid="store-modal-close">✕</div>
        </div>
        <div className="platform-tabs">
          {["shopee", "lazada", "tiktok"].map((p) => (
            <div key={p}
              className={`ptab ${p} ${platform === p ? "active" : ""}`}
              onClick={() => setPlatform(p)}
              data-testid={`platform-${p}`}>
              {platformIcon[p]} {platformLabel[p]}
            </div>
          ))}
        </div>
        <div className="country-row">
          {["MY", "SG", "ID", "TH", "PH"].map((c) => (
            <div key={c} className={`cflag ${country === c ? "active" : ""}`}
              onClick={() => setCountry(c)} data-testid={`country-${c}`}>{c}</div>
          ))}
        </div>
        <div className="store-list">
          {filtered.length === 0 ? (
            <div className="empty">No stores in scope for this filter.</div>
          ) : (
            filtered.map((s) => (
              <div key={s.id} className="store-item" onClick={() => onPick(s)} data-testid={`store-item-${s.id}`}>
                <div className="store-icon">🏪</div>
                <div>
                  <div className="store-name">{s.name}</div>
                  <div className="store-meta">{s.shop_id} · {platformLabel[s.platform]} · {s.country}</div>
                </div>
                <div className="store-status">
                  <span className={`badge ${s.status === "active" ? "b-active" : "b-pending"}`}>
                    ● {s.status === "active" ? "Live" : "Warn"}
                  </span>
                  <span style={{ color: "var(--muted)", fontSize: 18 }}>›</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
